import config from '../../config';

import { File } from '../../types';

import {
  getAccessTokenClient,
  getApiKeyClient,
  getAttendeeClient,
} from '../client/http';

const {
  apiBaseUrl: { elements: baseUrl },
} = config;

const accessTokenClient = () => getAccessTokenClient(baseUrl);
const apiKeyClient = () => getApiKeyClient(baseUrl);
const attendeeClient = () => getAttendeeClient(baseUrl);

export const filesCreate = async (files: File[], isPublic?: boolean) => {
  try {
    const client = isPublic ? attendeeClient : accessTokenClient;
    await client().put('api/files', JSON.stringify({ files }), {
      headers: { 'Content-Type': 'application/json' },
    });
  } catch (err: any) {
    throw new Error(`Error saving file: ${err.message}`);
  }
};

export const fileDelete = async (elementId: string, isPublic?: boolean) => {
  try {
    const client = isPublic ? apiKeyClient : accessTokenClient;
    await client().delete(`api/files/${elementId}`);
  } catch (err: any) {
    throw new Error(`Error deleting file: ${err.message}`);
  }
};

export const getAttendeeFaceVideos = async (
  eventId: string,
  parentElementId: string,
) => {
  try {
    const response = await attendeeClient().get(
      `api/event/${eventId}/face/${parentElementId}/files?fileKind=video-footage`,
    );
    return response.data.files;
  } catch (err: any) {
    throw new Error(`Error getting face videos: ${err.message}`);
  }
};

export const getAttendeeFacePhotos = async (
  eventId: string,
  parentElementId: string,
) => {
  try {
    const response = await attendeeClient().get(
      `api/event/${eventId}/face/${parentElementId}/files?fileType=image`,
    );
    return response.data.files;
  } catch (err: any) {
    throw new Error(`Error getting face images: ${err.message}`);
  }
};

export const getClipFiles = async (eventId: string, isPublic?: boolean) => {
  try {
    const client = isPublic ? apiKeyClient : accessTokenClient;
    const response = await client().get(
      `api/files?eventId=${eventId}&fileType=video&fileKind=VideoFootage`,
    );
    return response.data.files;
  } catch (err: any) {
    throw new Error(`Error getting clip files: ${err.message}`);
  }
};

export const getClipResults = async (eventId: string, isPublic?: boolean) => {
  try {
    const client = isPublic ? apiKeyClient : accessTokenClient;
    const response = await client().get(`api/clip-results?eventId=${eventId}`);
    return response.data;
  } catch (err: any) {
    throw new Error(`Error getting clip results: ${err.message}`);
  }
};
